import { Component } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ArendeInfoService } from './arende-info.service';
import { Arende } from '../../interfaces/arende.interface';
import { PortalenOvrigInfo } from '../../interfaces/portalenOvrigInfo.interface';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionService } from '../../session/session.service';
import { fadeInAnimation } from '../../_animations/fade-in.animation';

@Component({
  selector: 'app-arende-info',
  templateUrl: './arende-info.component.html',
  styleUrls: ['./arende-info.component.scss'],
  animations: [ fadeInAnimation ]
})
export class ArendeInfoComponent {

  constructor(
    protected service: ArendeInfoService,
    protected spinner: NgxSpinnerService,
    protected sessionService: SessionService,
    protected route: ActivatedRoute,
    protected router: Router) {
    this.loadArende();
  }

  public get isLoaded(): boolean { return !!this.arende };

  public arende: Arende;
  public get getOvrigInfo(): PortalenOvrigInfo[] {
    return this.isLoaded ? this.arende.ovrigInfo.filter(i => i.portalenOvrigInfo).map(i => Object.assign(i.portalenOvrigInfo, { sortering: i.sortering })) : []; }

  private loadArende(): void {

    const doLoad = () => {
      setTimeout(() => {
        if (!this.arende) {
          this.spinner.show();
        }
      }, 500);

      this.service.getArendeInfo(this.sessionService.activeInstance.id).subscribe(
        (result: Arende) => {
          this.spinner.hide();
          this.arende = result;
        },
        (error) => {
          this.spinner.hide();
        });
    };

    if (!this.sessionService.hasSession) {
      this.router.navigate(['/login']);
      return;
    }

    if (!this.sessionService.hasActiveInstance) {
      this.sessionService.selectInstance(doLoad);
      return;
    }

    doLoad();
  }

  public get instanceName(): string {
    return this.sessionService.activeInstance.name;
  }

  public openUrl(url: string): void {
    window.open(url, "_blank");
  }
}
